import { MUTATIONS } from "./types";
import routes from '../../router/wizard';
import { getInitialSpecs, getInitialConsult } from './index';

const mutations = {
    [MUTATIONS.SET_CATALOG](state, payload) {
        state.catalog = { ...payload };
    },
    [MUTATIONS.TOGGLE_CONSULT_APPLICATION](state, applicationId) {
        const { applications } = state.consult;
        if (applications.includes(applicationId)) {
            state.consult.applications = applications.filter(appId => appId !== applicationId);
        } else {
            state.consult.applications = [...applications, applicationId];
        }
    },
    [MUTATIONS.SET_CONSULT_ID](state, payload) {
        state.consult_id = payload;
    },
    [MUTATIONS.SET_LOADING_TO_TRUE](state, payload) {
        state.loading = true;
    },
    [MUTATIONS.SET_LOADING_TO_FALSE](state, payload) {
        state.loading = false;
    },
    [MUTATIONS.SET_UI](state, payload) {
        state.ui = { ...state.ui, ...payload };
    },
    [MUTATIONS.SET_CURRENT_STEP_INDEX](state, payload){
        state.ui.currentStepIndex = routes.findIndex((r)=> r.name === payload.name );
    },
    [MUTATIONS.SET_MAX_STEP_INDEX](state, payload){
        state.ui.maxStepIndex = payload;
    },
    [MUTATIONS.SET_CONSULT](state, payload){
        state.consult = {...payload}
    },
    [MUTATIONS.SET_PRODUCTS](state, products){
        state.products = products;
    },
    [MUTATIONS.RESET_SPECS](state) {
        state.consult = { ...state.consult, ...getInitialSpecs() };
    },
    [MUTATIONS.RESET_CONSULT](state) {
        state.consult = getInitialConsult();
        state.consult_id = null;
        state.products = [];
    }
};

export default mutations;
